import { Component, computed, inject, input, OnInit, output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { NavTab } from './navigation-tabs.interfaces';
import { NavTabsService } from './services/nav-tabs.service';
import { NavTabsStoreService } from './services/nav-tabs-store.service';
import { AvatarComponent } from '../../molecules/avatar/avatar.component';
import { ThemedIconComponent } from '../../atoms/themed-icon/themed-icon.component';

@Component({
  selector: 'ocp-navigation-tabs',
  imports: [RouterLink, RouterLinkActive, TranslatePipe, AvatarComponent, ThemedIconComponent],
  templateUrl: './navigation-tabs.component.html',
  styleUrl: './navigation-tabs.component.scss',
  providers: [NavTabsService, NavTabsStoreService],
})
export class NavigationTabsComponent implements OnInit {
  private readonly navTabsService = inject(NavTabsService);
  private readonly navTabsStoreService = inject(NavTabsStoreService);

  readonly excludeHome = input(false);

  readonly tabs = computed(() => {
    const all = this.navTabsStoreService.tabs();
    if (this.excludeHome()) {
      return all.filter(tab => tab.route !== '/');
    }
    return all;
  });

  readonly tabSelected = output<NavTab>();

  ngOnInit(): void {
    this.navTabsService.initRouteListener();
  }

  selectTab(tab: NavTab): void {
    this.tabSelected.emit(tab);
  }
}
